import React from "react";
import { Box } from "@indeed/ifl-components";
import type { SystemStyleObject } from "@indeed/ifl-css";
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";

export interface ArticleCardImgProps {
  alt: string;
  image: string;
  gatsbyImageData?: IGatsbyImageData;
  sx?: SystemStyleObject;
}

export const ArticleCardImg: React.FC<ArticleCardImgProps> = ({
  image,
  gatsbyImageData,
  alt,
  sx,
}) => (
  <Box
    as={gatsbyImageData ? GatsbyImage : "img"}
    image={gatsbyImageData}
    src={image}
    alt={alt}
    sx={{
      m: 0,
      width: "100%",
      mb: [4, null, null, 0],
      ...sx,
    }}
  />
);
